import api from "./axiosConfig";
import { LoginRequest } from "./models/LoginRequest";

export const authenticate = async (req : LoginRequest) => {
  return api.post(`/user/login`, req);
}